module.exports = __webpack_public_path__ + "static/kwekkwekfinal-ef3fbe768bce5a787e194966ca102b82.jpg";